import ErrorCode from './ErrorCode.jsx';

export default ErrorCode;